export interface List<T> {
  length: number;
  [index: number]: T;
}

export function* listIterator<T>(list: List<T>): IterableIterator<T> {
  for (let i = 0; i < list.length; i++) {
    yield list[i];
  }
}

export function* listReverseIterator<T>(list: List<T>): IterableIterator<T> {
  for (let i = list.length - 1; 0 <= i; i--) {
    yield list[i];
  }
}
